import React from "react"
import PropTypes from "prop-types"
import Grid from "@mui/material/Grid"
import ChatIcon from "@mui/icons-material/ChatBubble"
import EmailIcon from "@mui/icons-material/Email"
import PhoneIcon from "@mui/icons-material/Phone"

import IconTextBlock from "./product-marketing/IconTextBlock"
import { phoneNumber, SUPPORT_EMAIL } from "../../config"

const ContactHeroBlock = ({ includeEmail }) => (
  <Grid container spacing={1}>
    <Grid item xs={12} md={includeEmail ? 4 : 6}>
      <IconTextBlock
        head="Chat"
        text={
          <>
            Text us at <a href={`sms:${phoneNumber}`}>{phoneNumber}</a>.
          </>
        }
        icon={<ChatIcon />}
      />
    </Grid>
    {includeEmail ? (
      <Grid item xs={12} md={4}>
        <IconTextBlock
          head="Email"
          linkText={SUPPORT_EMAIL}
          icon={<EmailIcon />}
          link={`mailto:${SUPPORT_EMAIL}`}
        />
      </Grid>
    ) : null}
    <Grid item xs={12} md={includeEmail ? 4 : 6}>
      <IconTextBlock
        head="Phone"
        linkText={phoneNumber}
        icon={<PhoneIcon />}
        link={`tel:${phoneNumber}`}
      />
    </Grid>
  </Grid>
)

ContactHeroBlock.propTypes = {
  includeEmail: PropTypes.bool,
}

ContactHeroBlock.defaultProps = {
  includeEmail: true,
}

export default ContactHeroBlock
